<template>
  <div class="publicizeList">
    <div class="banner">
      <img src="@/assets/images/xuanchuanxinxi.jpg" alt="">
      <div class="weizhi">
        <i class="iconfont icon-dizhi"></i> 当前位置：首页 > 宣传信息
      </div>
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="back">
          <b></b>
          <span @click="$router.go(-1)">
            <i class="iconfont icon-prev_arrow-copy"></i>返回
          </span>
        </div>

        <div class="list-box">
          <div class="item" v-for="item in lists" :key="item.id" @click="to('/masses/detail',item.id,3)">
            <div class="item-date">
              <b>{{item.publish_time.substring(8, 10)}}</b>
              <p>{{item.publish_time.substring(0, 7)}}</p>
            </div>
            <div class="item-line">
              <i class="iconfont icon-arrfill_d-copy-copy"></i>
              <b></b>
            </div>
            <div class="item-cont">
              <div class="item-title ovHide">{{item.title}}</div>
              <div class="item-desc ovHide3">{{item.desc}}</div>
              <div class="item-more">
                探索更多<i class="iconfont icon-arrow-right"></i>
              </div>
            </div>
            <div class="item-img">
              <img :src="item.thumb" alt="">
            </div>
          </div>
        </div>

        <div class="masses-pagebox">
          <el-pagination
            :current-page.sync="search.page"
            :page-size="search.limit"
            :total="search.total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next"
            @current-change="list">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {masses_article_lst} from "@/api";

export default {
  name: "publicizeList",
  data() {
    return {
      type:1,
      lists:[],
      search:{
        page:1,
        limit:10,
        total:0,
      },
    }
  },
  components: {},
  created() {
    this.type = this.$route.query.type
    this.list()
  },
  methods: {
    async list(){
      let _data = await masses_article_lst(
        this.search.page,
        this.search.limit,
        this.type
      );
      this.lists = _data.data.data;
      this.search.total = _data.data.total;
    },
    searchFun(){
      this.search.page = 1
      this.list()
    },
    to(path,id,type){
      this.$router.push({
        path: path,
        query: {
          id: id,
          type:type
        }
      })
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      .item {
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cecece;
        &:hover {
          background-color: #ffffff;
          box-shadow: 11px 8px 18px 0px
          rgba(0, 46, 108, 0.17);
          border-radius: 8px;
          border: solid 1px #ffffff;
          .item-cont {
            .item-title {
              color: #0d7bff;
            }
          }
          .item-line {
            i {
              opacity: 1;
            }
          }
          .item-date {
            b {
              color: #ffffff;
            }
            p {
              color: #ffffff;
            }
            background-color: #428ffb;
          }
        }
        .item-img {
          width: 415px;
          height: 300px;
          padding: 30px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 5px;
          }
        }
        .item-cont {
          flex: 1;
          width: 0;
          height: 300px;
          padding: 65px 70px 50px 20px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .item-more {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            color: #434950;
            i {
              color: #4598fb;
              font-size: 24px;
              margin-left: 2px;
            }
          }
          .item-desc {
            width: 100%;
            font-size: 16px;
            line-height: 28px;
            color: #434950;
          }
          .item-title {
            width: 100%;
            font-size: 22px;
            color: #141c24;
          }
        }
        .item-line {
          width: 45px;
          height: 300px;
          display:flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          b {
            flex: 1;
            height: 1px;
            background-color: #cecece;
            margin-left: -4px;
            margin-top: 1px;

          }
          i {
            font-size: 26px;
            color: #428ffb;
            margin-left: -10px;
            opacity: 0;
          }
        }
        .item-date {
          width: 135px;
          height: 300px;
          display:flex;
          justify-content: center;
          flex-direction: column;
          p {
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #000000;
          }
          b {
            width: 100%;
            text-align: center;
            font-size: 70px;
            color: #000000;
            line-height: 80px;
          }
        }
      }
    }
    .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      span {
        font-size: 18px;
        color: #428ffb;
        width: 105px;
        height: 45px;
        border-radius: 22px;
        border: solid 1px #428ffb;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #428ffb;
        }
      }
    }
  }
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      width: 1500px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -750px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #ffffff;
      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>


